import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Text.module.css';

export type TextColor =
  | 'primary'
  | 'secondary'
  | 'muted'
  | 'dimmed'
  | 'error'
  | 'success'
  | 'inherit';

export type TextProps = HTMLAttributes<HTMLParagraphElement> & {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  fw?: 400 | 500 | 600 | 700;
  c?: TextColor;
  /** Margin top in px */
  mt?: number;
  tt?: 'uppercase' | 'none';
  ta?: 'left' | 'center' | 'right';
  ff?: 'mono' | 'body' | 'display';
  component?: 'p' | 'span' | 'div';
  children: ReactNode;
};

export function Text({
  size = 'md',
  fw,
  c = 'primary',
  mt,
  tt,
  ta,
  ff = 'display',
  component: Comp = 'p',
  className,
  style,
  children,
  ...rest
}: TextProps) {
  return (
    <Comp
      className={cx(styles.text, styles[`size_${size}`], styles[`c_${c}`], ff && styles[`ff_${ff}`], className)}
      style={{
        fontWeight: fw,
        marginTop: mt != null ? `${mt}px` : undefined,
        textTransform: tt,
        textAlign: ta,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Comp>
  );
}
